import React from 'react';
import {imagesURL} from 'config';
import RadioGroup from 'components/flink-components/ActivityOptions/RadioGroup';

// Reuse the application's native radio group in both completed Make and Play.
export default function NativeChoiceAnswers({choices, selected, disabled, onSelect, onListen, withAudio}) {
  return <fieldset disabled={disabled} className="native-math-rods-choices">
    <RadioGroup name="mathRodsChoice" numeric current={{mathRodsChoice: selected}}
      changeHandler={(_, value) => onSelect(value)} options={choices.map(choice => ({
        value: choice.index,
        label: <><span>{choice.label}</span>{withAudio && choice.audio && <button type="button" className="choice-audio"
          aria-label={choice.listenLabel} title={choice.listenLabel}
          onClick={event => {event.preventDefault(); event.stopPropagation(); onListen(choice.audio);}}><img src={`${imagesURL}/Images/Audio/audio_make.png`} alt="" style={{width:24,height:24}} /></button>}</>,
      }))} />
  </fieldset>;
}
